import * as z from "zod/v4";
import { IntegrationV2Schema } from "./integration-v2.js";

const IntegrationV2ResponseSchema_ = z.object({
  integration: IntegrationV2Schema,
});
export const IntegrationV2ResponseSchema: z.ZodType<IntegrationV2Response> =
  IntegrationV2ResponseSchema_;
export interface IntegrationV2Response
  extends z.infer<typeof IntegrationV2ResponseSchema_> {}
